<script>
  import { blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link, links } from "svelte-routing";

  export let block;
</script>

<footer class="footer">
  <div class="footer-top">
    <div class="container">
      <div class="row gy-4">
        <div class="col-lg-5 col-md-12 footer-info">
          <a href="index.html" class="logo d-flex align-items-center">
            <img src="{image(block, 'logo', [500, 500])}" alt="">
            <span>{text(block, 'logoText')}</span>
          </a>
          <p>
            {@html richtext(block, 'description')}
          </p>
          <div class="social-links mt-3">
            {#each blocklist(block, 'socialLinks') as item}
            <a href="{url(item, 'link')}" class="{text(item, 'iconName')}">
              <i class="bi bi-{text(item, 'iconName')}"></i>
            </a>
            {/each}
          </div>
        </div>

        <div class="col-lg-2 col-6 footer-links">
          <h4>{text(block, 'columnOneTitle')}</h4>
          <ul>
            {#each blocklist(block, 'columnOneLinks') as item}
            <li><i class="bi bi-chevron-right"></i> <a href="{url(item, 'link')}" use:link>{text(item, 'link')}</a></li>
            {/each}
          </ul>
        </div>

        <div class="col-lg-2 col-6 footer-links">
          <h4>{text(block, 'columnTwoTitle')}</h4>
          <ul>
            {#each blocklist(block, 'columnTwoLinks') as item}
            <li><i class="bi bi-chevron-right"></i> <a href="{url(item, 'link')}" use:link>{text(item, 'link')}</a></li>
            {/each}
          </ul>
        </div>

        <div class="col-lg-3 col-md-12 footer-contact text-center text-md-start">
          <h4>{text(block, 'columnThreeTitle')}</h4>
          <p>
            {@html richtext(block, 'columnThreeBody')}
          </p>

        </div>

      </div>
    </div>
  </div>

  <div class="container">
    <div class="mt-4">
      {@html richtext(block, 'copyright')}
    </div>
  </div>
</footer>
